import request from '@/utils/server'
 

// 新增轮播图
export function addCarousel(data) {
    return request({
      url: '/carousel/addCarousel',
      method: 'POST',
      data:data
    })
  }
  export function getCarouselList(query) {
    return request({
      url: '/carousel/getCarouselList',
      method: 'get',
  params: query
    })
  }
  export function delCarousel(data) {
    return request({
      url: '/carousel/delCarousel',
      method: 'POST',
      data:data
    })
  }

// 新增公告
// 新增公告
   export function addNotice(data) {
    return request({
      url: '/notice/addNotice',    
      method: 'POST',
      data:data
    })
  }
  // 获取公告
     export function getNoticeList(query) {
    return request({
      url: '/notice/getNoticeList',    
      method: 'GET',
    params:query
    })
  }
  // 删除公告
   export function delNotice(data) {
    return request({
      url: '/notice/delNotice',    
      method: 'POST',
      data:data
    })
  }
  